var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasySignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Up_Right",
    "data-name": "Up Right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.994,
    height: 42.994,
    viewBox: "0 0 42.994 42.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11898",
    "data-name": "Path 11898",
    d: "M24.648,38.529a1.72,1.72,0,0,1-1.216-2.936L35.594,23.433a1.72,1.72,0,1,1,2.432,2.432L25.864,38.025a1.714,1.714,0,0,1-1.216.5Z",
    transform: "translate(-9.232 -9.232)",
    fill: "#d7df23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11899",
    "data-name": "Path 11899",
    d: "M37.008,26.368H26.063a1.72,1.72,0,0,1,0-3.44H37.008a1.72,1.72,0,0,1,0,3.44Z",
    transform: "translate(-9.43 -9.232)",
    fill: "#d7df23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11900",
    "data-name": "Path 11900",
    d: "M38.791,37.313a1.72,1.72,0,0,1-1.72-1.72V24.648a1.72,1.72,0,0,1,3.44,0V35.593A1.72,1.72,0,0,1,38.791,37.313Z",
    transform: "translate(-11.214 -9.232)",
    fill: "#d7df23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11901",
    "data-name": "Path 11901",
    d: "M48.274,49.994H8.72A1.72,1.72,0,0,1,7,48.274V8.72A1.72,1.72,0,0,1,8.72,7H41.663a1.72,1.72,0,1,1,0,3.44H10.44V46.555H46.555V8.72a1.72,1.72,0,0,1,3.44,0V48.274A1.72,1.72,0,0,1,48.274,49.994Z",
    transform: "translate(-7 -7)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasySignup);
export default __webpack_public_path__ + "static/media/easySignup.f9c2295cdbf9abbc03803fb9aadafcfd.svg";
export { ForwardRef as ReactComponent };